/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Trace_Mint_ErrorInputs */

const vi_toast_trace_mint_error = /** @type {(inputs: Toast_Trace_Mint_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo mã truy xuất thất bại`)
};

/**

* @param {Toast_Trace_Mint_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_trace_mint_error = /** @type {((inputs?: Toast_Trace_Mint_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Trace_Mint_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_trace_mint_error(inputs)
});